import { Stack, SxProps, Theme, Typography } from "@mui/material";
import { useLocales } from "src/locales";
import { formatNumber } from "src/utils/format-number";

export interface SplitBarCellData {
    name: string;
    value: number;
    color: string;
    format?: (value: number) => string;
}

export interface SplitBarCellProps {
    data: SplitBarCellData[];
    total: number;
    format: (value: number) => string;
    sx?: any
}

export default function SplitBarCell({ data, total, format, sx }: SplitBarCellProps) {
    if (!data.length) {
        return (
            <Stack
                direction="row"
                alignItems="center"
                spacing={1.25}
                py={1}
                sx={{ width: '100%', minHeight: '52px' }}
            >
                <Typography variant="body2">-</Typography>
            </Stack>
        );
    }

    const totalValues = data.reduce((acc, item) => acc + item.value, 0);

    return (
        <Stack direction="row" alignItems="center" spacing={1.25} py={1} sx={{ width: 'fill-available', minHeight: '52px' }}>
            <Typography
                variant="body2"
                sx={{
                    fontVariantNumeric: 'lining-nums tabular-nums',
                    color: '#333C47',
                    fontFamily: 'Public Sans',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: '22px',
                    minWidth: '48px',
                }}
            >
                {format(total)}
            </Typography>
            <Stack
                direction="row"
                spacing={"1.5px"}

                sx={{
                    width: 'fill-available',
                    height: sx?.height || 6,
                    my: sx?.my || 0,
                    borderRadius: '999px',
                    backgroundColor: 'white',
                    overflow: 'hidden',
                }}
            >

                {data.map((item, index) => (
                    <Stack
                        sx={{
                            height: sx?.height || 6,
                            flex: totalValues > 0 ? (item.value / totalValues) * 100 : 0,
                            backgroundColor: item.color,
                            minWidth: '2px',
                            borderRadius: {
                                left: index <= data.length - 1 ? '2px' : '0px',
                                right: index >= 0 ? '2px' : '0px',
                            },
                        }}
                    />
                ))}
            </Stack>
        </Stack>
    );
}